import type { MqttMessage } from '@store/atoms/mqtt/types';

export function createErrorMessage(topic: string, error: unknown): MqttMessage {
  return {
    value: null,
    topic,
    timestamp: Date.now(),
    error: error instanceof Error ? error.message : String(error),
  };
}

export function createValidationErrorMessage(topic: string): MqttMessage {
  return createErrorMessage(topic, 'Validation failed');
}

export function generateSubscriberId(): string {
  return `subscriber_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
}

export function generateMultiSubscriberId(): string {
  return `multi-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

const isMqttLoggingEnabled = process.env.VITE_ENABLE_MQTT_LOGGING === 'true';

export const mqttLogger = {
  debug: (message: string, data?: unknown) => {
    if (isMqttLoggingEnabled) {
      console.debug(`[MQTT] ${message}`, data ?? '');
    }
  },
  info: (message: string, data?: unknown) => {
    if (isMqttLoggingEnabled) {
      console.info(`[MQTT] ${message}`, data ?? '');
    }
  },
  warn: (message: string, data?: unknown) => {
    if (isMqttLoggingEnabled) {
      console.warn(`[MQTT] ${message}`, data ?? '');
    }
  },
  error: (message: string, error?: unknown) => {
    if (isMqttLoggingEnabled) {
      if (error === undefined) {
        console.error(`[MQTT] ${message}`);
      } else if (error instanceof Error) {
        console.error(`[MQTT] ${message}`, error.message, error.stack);
      } else {
        console.error(`[MQTT] ${message}`, String(error));
      }
    }
  },
};
